import React from "react";
import { useI18n } from "../i18n/I18nContext";

const ACCENTS = [
  { bar: "#00ffff", text: "text-[#00ffff]", glow: "glow-cyan" },
  { bar: "#ff0044", text: "text-[#ff0044]", glow: "glow-pink" },
  { bar: "#2bff88", text: "text-[#2bff88]", glow: "glow-green" },
  { bar: "#ffe600", text: "text-[#ffe600]", glow: "glow-yellow" },
  { bar: "#00ffff", text: "text-[#00ffff]", glow: "glow-cyan" },
  { bar: "#ff0044", text: "text-[#ff0044]", glow: "glow-pink" },
  { bar: "#ffe600", text: "text-[#ffe600]", glow: "glow-yellow" },
];

export const PlanetsSection = () => {
  const { t } = useI18n();
  const items = t.planets.items;

  return (
    <section
      id="planets"
      data-testid="planets-section"
      className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-28"
    >
      <div className="mb-12">
        <div className="section-tag">{t.planets.title}</div>
        <h2 className="font-pixel text-[#ff0044] glow-pink text-4xl sm:text-6xl mt-2 tracking-widest">
          {t.planets.title}
        </h2>
        <p className="font-mono text-[#94a3b8] text-sm mt-3 max-w-2xl">{t.planets.subtitle}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((p, i) => {
          const acc = ACCENTS[i % ACCENTS.length];
          const isFinal = i === items.length - 1;
          return (
            <article
              key={p.n}
              data-testid={`planet-card-${p.n}`}
              className={`planet-card p-5 ${isFinal ? "sm:col-span-2 lg:col-span-2" : ""}`}
            >
              <div className="flex items-center justify-between">
                <div className={`font-pixel text-3xl ${acc.text} ${acc.glow}`}>{p.n}</div>
                <div className="flex items-center gap-1">
                  {Array.from({ length: i + 1 }).map((_, k) => (
                    <span key={k} className="block w-2 h-2" style={{ background: acc.bar, boxShadow: `0 0 8px ${acc.bar}` }} />
                  ))}
                </div>
              </div>
              <h3 className={`font-pixel text-2xl mt-2 tracking-widest ${acc.text} ${acc.glow}`}>{p.name}</h3>
              <p className="font-mono text-sm text-[#e2e8f0]/80 mt-3 leading-relaxed">{p.desc}</p>
              {isFinal && (
                <div className="mt-4 font-pixel text-base text-[#ff0044] glow-pink tracking-widest">
                  ▲ FINAL BOSS
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default PlanetsSection;
